module.exports = __webpack_public_path__ + "img/winning_bg.22c03b76.png";